import React, { useEffect } from "react";
import { X } from "lucide-react";

const ShippingInfoModal = ({ open, onClose }) => {
  useEffect(() => {
    if (!open) return;
    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = originalOverflow;
    };
  }, [open]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50">
      <div
        className="absolute inset-0 bg-black/60 backdrop-blur-sm"
        onClick={onClose}
      />
      <div className="absolute max-w-3xl pb-4 mx-auto overflow-y-auto bg-white shadow-2xl h-fit inset-x-4 top-14 bottom-4 rounded-2xl">
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200">
          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-gray-500">
              Shipping
            </p>
            <h3 className="font-serif text-2xl text-gray-900">
              Shipping Information
            </h3>
          </div>
          <button
            onClick={onClose}
            className="p-2 text-gray-500 transition rounded-full hover:text-gray-900 hover:bg-gray-100"
            aria-label="Close shipping info"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="px-5 py-4 space-y-4 text-sm text-gray-700">
          <section className="space-y-2">
            <h4 className="text-lg font-semibold text-gray-900">
              Processing time
            </h4>
            <p>All orders are processed within 1–2 business days.</p>
          </section>

          <section className="space-y-2">
            <h4 className="text-lg font-semibold text-gray-900">
              Shipping methods
            </h4>
            <ul className="space-y-2">
              <li>
                <span className="font-medium">Local Delivery (Lebanon):</span>{" "}
                Delivery within 2–4 business days.
              </li>
              <li>
                <span className="font-medium">International Shipping:</span>{" "}
                Delivery within 5–12 business days depending on destination.
              </li>
            </ul>
          </section>

          <section className="space-y-2">
            <h4 className="text-lg font-semibold text-gray-900">
              Shipping fees
            </h4>
            <ul className="space-y-1">
              <li>Local: $6 standard, $9 express</li>
              <li>International: Contact us for details.</li>
            </ul>
          </section>

          <section className="space-y-2">
            <h4 className="text-lg font-semibold text-gray-900">
              Order tracking
            </h4>
            <p>
              Once your order ships, you will receive an SMS with a tracking
              number and a link to track your package.
            </p>
          </section>

          <section className="space-y-2">
            <h4 className="text-lg font-semibold text-gray-900">
              Shipping notes
            </h4>
            <ul className="space-y-1 list-disc list-inside">
              <li>
                We are not responsible for delays caused by courier or customs.
              </li>
              <li>
                Please ensure your shipping address and phone number are correct
                to avoid delays.
              </li>
            </ul>
          </section>

          <section className="space-y-2">
            <h4 className="text-lg font-semibold text-gray-900">
              Optional add-ons
            </h4>
            <ul className="space-y-1 list-disc list-inside">
              <li>Every piece is packed carefully to ensure it arrives safely.</li>
              <li>We offer special gift packaging upon request.</li>
              <li>We ship worldwide.</li>
              <li>VIP Express Delivery available in Lebanon.</li>
            </ul>
          </section>
        </div>
      </div>
    </div>
  );
};

export default ShippingInfoModal;
